import Vue from "vue";
import App from "./App.vue";
import Vuelidate from "vuelidate";
import VueCharts from "vue-chartjs";
import axios from "axios";
import router from "./router.js";
import store from "./Store/index";
import Notification from "vue-notification";
import { stupInterseptors } from "./Store/httpInterceptor";
import { BootstrapVue, BootstrapVueIcons, ModalPlugin, IconsPlugin } from "bootstrap-vue";
import moment from "moment";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";

Vue.filter("formatDate", function(value) {
  if (value) {
    moment.locale("id");
    return moment(String(value)).format("DD MMMM YYYY");
  }
});

Vue.filter("formatDateTime", function(value) {
  if (value) {
    moment.locale("id");
    return moment(String(value)).format("DD MMMM YYYY HH:mm");
  }
});
Vue.filter("formatDateTimeFull", function(value) {
  if (value) {
    moment.locale("id");
    return moment(String(value)).format("DD MMMM YYYY HH:mm:ss");
  }
});

Vue.filter("day", function(value) {
  if (value) {
    moment.locale("id");
    return moment(String(value)).format("dddd");
  }
});

Vue.filter("date", function(value) {
  if (value) {
    moment.locale("id");
    return moment(String(value)).format("DD");
  }
});

Vue.filter("month", function(value) {
  if (value) {
    moment.locale("id");
    return moment(String(value)).format("MMMM");
  }
});

Vue.filter("year", function(value) {
  if (value) {
    return moment(String(value)).format("YYYY");
  }
});

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(ModalPlugin);
Vue.use(VueCharts);
Vue.use(Notification);

Vue.config.productionTip = false;

Vue.use(Toast, {
  position: "top-center",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

// axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.baseURL = process.env.VUE_APP_API_URL_PROD;

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    if (err.response.status == 498) {
      localStorage.clear();
      location.reload();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

new Vue({
  router,
  created() {
    stupInterseptors(store);
  },
  store,
  render: (h) => h(App),
}).$mount("#app");
